import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de99d138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "modalDadosLoja",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = { class: "modal-header p-3" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-0 align-items-center\" data-v-de99d138><div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\" data-v-de99d138><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" fill=\"#0045B5\" data-v-de99d138><g fill=\"#0045B5\" clip-path=\"url(#a)\" data-v-de99d138><path d=\"M23.938 4.25H19.25A3.753 3.753 0 0 0 15.5.5a3.753 3.753 0 0 0-3.75 3.75H7.063A2.813 2.813 0 0 0 4.25 7.063v20.625A2.813 2.813 0 0 0 7.063 30.5h16.875a2.813 2.813 0 0 0 2.812-2.812V7.063a2.813 2.813 0 0 0-2.812-2.813M9.875 25.344c-.78 0-1.406-.627-1.406-1.407 0-.779.627-1.406 1.406-1.406.78 0 1.406.627 1.406 1.407 0 .779-.627 1.406-1.406 1.406m0-5.625c-.78 0-1.406-.627-1.406-1.407 0-.779.627-1.406 1.406-1.406.78 0 1.406.627 1.406 1.407 0 .779-.627 1.406-1.406 1.406m0-5.625c-.78 0-1.406-.627-1.406-1.406 0-.78.627-1.407 1.406-1.407.78 0 1.406.627 1.406 1.406 0 .78-.627 1.407-1.406 1.407M15.5 2.844c.78 0 1.406.627 1.406 1.406 0 .78-.627 1.406-1.406 1.406-.78 0-1.406-.627-1.406-1.406 0-.78.627-1.406 1.406-1.406M23 24.406a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.469-.469v-.937a.47.47 0 0 1 .469-.469h8.437a.47.47 0 0 1 .469.469zm0-5.625a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.469-.469v-.937a.47.47 0 0 1 .469-.469h8.437a.47.47 0 0 1 .469.469zm0-5.625a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.469-.469v-.937a.47.47 0 0 1 .469-.469h8.437a.47.47 0 0 1 .469.469z\" opacity=\".3\" data-v-de99d138></path><path d=\"M9.875 25.344c-.78 0-1.406-.627-1.406-1.407 0-.779.627-1.406 1.406-1.406.78 0 1.406.627 1.406 1.407 0 .779-.627 1.406-1.406 1.406m0-5.625c-.78 0-1.406-.627-1.406-1.407 0-.779.627-1.406 1.406-1.406.78 0 1.406.627 1.406 1.407 0 .779-.627 1.406-1.406 1.406m0-5.625c-.78 0-1.406-.627-1.406-1.406 0-.78.627-1.407 1.406-1.407.78 0 1.406.627 1.406 1.406 0 .78-.627 1.407-1.406 1.407M23 24.406a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.469-.469v-.937a.47.47 0 0 1 .469-.469h8.437a.47.47 0 0 1 .469.469zm0-5.625a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.469-.469v-.937a.47.47 0 0 1 .469-.469h8.437a.47.47 0 0 1 .469.469zm0-5.625a.47.47 0 0 1-.469.469h-8.437a.47.47 0 0 1-.469-.469v-.937a.47.47 0 0 1 .469-.469h8.437a.47.47 0 0 1 .469.469z\" data-v-de99d138></path></g><defs data-v-de99d138><clipPath id=\"a\" data-v-de99d138><path fill=\"#fff\" d=\"M.5.5h30v30H.5z\" data-v-de99d138></path></clipPath></defs></svg></div><div data-v-de99d138><p class=\"m-0 fs-1 cor_texto_1\" style=\"font-weight:bold;\" data-v-de99d138>Informações da loja</p></div></div>", 1)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "modal-body d-flex flex-column p-5 gap-5",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_10 = { class: "d-flex flex-column gap-3 m-0 p-0 col-12" }
const _hoisted_11 = { class: "d-flex gap-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cor_texto_1",
  style: {"font-weight":"bold"}
}, "Nome:", -1))
const _hoisted_13 = { class: "d-flex gap-1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cor_texto_1",
  style: {"font-weight":"bold"}
}, "Cnpj:", -1))
const _hoisted_15 = { class: "d-flex gap-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cor_texto_1",
  style: {"font-weight":"bold"}
}, "Status:", -1))
const _hoisted_17 = { class: "d-flex gap-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cor_texto_1",
  style: {"font-weight":"bold"}
}, "Data criação:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fecharModal && _ctx.fecharModal(...args))),
              "aria-label": "Close"
            }, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_ctx.loja.nomeFantasia), 1)
              ]),
              _createElementVNode("li", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(_ctx.loja.cnpj), 1)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(_ctx.loja.status), 1)
              ]),
              _createElementVNode("li", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", null, _toDisplayString(_ctx.loja.created_at), 1)
              ])
            ])
          ]),
          _hoisted_19
        ])
      ])
    ])
  ]))
}